import type {RootState} from '../index'

export const selectAuth = (state: RootState) => state.auth

// Reactive "create your first workspace" onboarding (SCD-933). Derived from FULLY-RESOLVED
// state — signed in, the live workspaces listener has settled (workspacesLoading=false), and
// there are genuinely zero workspaces — instead of being opened imperatively from
// loadUserData's one-shot membership read. A transient/stale empty read on a deep-link load
// no longer strands the user: when the live listener delivers the real workspace,
// workspaces.length > 0 and this flips to false, so the modal can't sit over a loaded
// workspace. While auth is still resolving (globalLoading or workspacesLoading) it returns
// false, so the user sees the loader, never a no-exit modal. Gated on no other modal being
// open so it never stacks over the email-verification / workspace-picker modals.
export const selectShouldShowCreateWorkspaceOnboarding = (state: RootState): boolean =>
    state.auth !== null &&
    !state.ui.globalLoading &&
    !state.auth.workspacesLoading &&
    state.auth.workspaces.length === 0 &&
    state.ui.openModal === null
